import { getDefaultCustomStyles, CustomStylesProps } from 'utils/inputSelect';

const LIGHT_GREY = '#f4f5f6';
export const LIGHT_ORANGE = '#fff2e6';
const WHITE = '#ffffff';

export const customStyles = ({ ...rest }: CustomStylesProps) => {
  const defaultCustomStyles = getDefaultCustomStyles({ ...rest });
  const defaultOption = defaultCustomStyles.option;

  const determineBackgroundColor = (state: any) => {
    if (state.data.__isNew__) {
      return LIGHT_GREY;
    }

    if (state.isSelected) {
      return LIGHT_ORANGE;
    }

    return WHITE;
  };

  return {
    ...defaultCustomStyles,
    option: (provided: any, state: any) => ({
      ...defaultOption(provided, state),
      backgroundColor: determineBackgroundColor(state),
      borderColor: 'inherit',
    }),
  };
};
